import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { EXTERNAL_AE_URL, EXTERNAL_URL } from "src/_config";

interface UserInfoSectionProps {
  userSelector: any;
  userType: string;
  formatPhoneNumber: (phone?: string | null, phoneCode?: string) => string;
  stripHtmlTags: (html?: string) => string;
  cityName: string;
  locationName: string;
}

const UserInfoSection: React.FC<UserInfoSectionProps> = ({
  userSelector,
  userType,
  formatPhoneNumber,
  stripHtmlTags,
  cityName,
  locationName,
}) => {
  const { t } = useTranslation("member");

  return (
    <div className="row">
      <div className="col-md-12">
        {/* Personal Information Section */}
        <div className="personal-info-card">
          <div className="personal-info-header">
            <h2 className="section-title">
              {userType == "member" ? t("members.profile.personalInfo.title") : t("members.profile.companyInfo.title")}
            </h2>
            <p className="section-subtitle">{t("members.profile.companyInfo.subtitle")}</p>
          </div>

          <div className="personal-info-content">
            <div className="info-grid">
              {/* <div className="info-row">
                <div className="info-field">
                  <div className="field-label">{t("members.profile.companyInfo.fields.emailAddress")}</div>
                  <div className="field-value">
                    {userSelector?.user?.email || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
                {userSelector?.user?.mobile_number && (
                  <div className="info-field">
                    <div className="field-label">{t("members.profile.companyInfo.fields.phoneNumber")}</div>
                    <div className="field-value">
                      {userSelector?.user?.mobile_number
                        ? `${userSelector?.user?.country_code} ${userSelector?.user?.mobile_number} `
                        : null}
                    </div>
                  </div>
                )}
              </div> */}

              {userSelector?.company && (
                <>
                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.companyName")}</div>
                      <div className="field-value">
                        {userSelector?.company?.name || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>

                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.companyFoundedYear")}</div>
                      <div className="field-value">
                        {userSelector.company.founded_year || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.companyType")}</div>
                      <div className="field-value">
                        {userSelector.company.type || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.numberOfEmployees")}</div>
                      <div className="field-value">
                        {userSelector.company.no_of_employees || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.industry")}</div>
                      <div className="field-value">
                        {userSelector.company.industry || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.companyLocation")}</div>
                      <div className="field-value">
                        {cityName && locationName
                          ? cityName + ", " + locationName
                          : cityName || locationName || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>

                  {/* <div className="info-row"> */}
                  {/* <div className="info-field">
                  <div className="field-label">{t("members.profile.companyInfo.fields.emailVerified")}</div>
                  <div className="field-value">
                    {userSelector?.user?.emailverified
                      ? t("members.profile.companyInfo.values.yes")
                      : t("members.profile.companyInfo.values.no")}
                  </div>
                </div> */}
                  {/* <div className="info-field">
                  <div className="field-label">Member Since</div>
                  <div className="field-value">{formatDate(userSelector?.user?.created_at)}</div>
                </div> */}
                  {/* </div> */}

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.companyWebsite")}</div>
                      <div className="field-value">
                        {userSelector.company.website || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                    <div className="info-field">
                      <div className="field-label">{t("members.profile.companyInfo.fields.howDidYouHear")}</div>
                      <div className="field-value">
                        {userSelector?.company?.referred_by || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>
                  {userSelector.company.about && (
                    <div className="info-row full-width">
                      <div className="info-field">
                        <div className="field-label">{t("members.profile.companyInfo.fields.companyAbout")}</div>
                        <div className="field-value">{stripHtmlTags(userSelector.company.about)}</div>
                      </div>
                    </div>
                  )}

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">Recruiter Name</div>
                      <div className="field-value">
                        {userSelector?.company?.recruiter_name || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                    <div className="info-field">
                      <div className="field-label">Recruiter Designation</div>
                      <div className="field-value">
                        {userSelector?.company?.recruiter_designation || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">Recruiter Phone</div>
                      <div className="field-value">
                        {userSelector?.company?.recruiter_mobile
                          ? `${userSelector?.company?.recruiter_country_code} ${userSelector?.company?.recruiter_mobile} `
                          : t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                    <div className="info-field">
                      <div className="field-label">Recruiter Email</div>
                      <div className="field-value">
                        {userSelector?.company?.recruiter_email || t("members.profile.personalInfo.notProvided")}
                      </div>
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="info-field">
                      <div className="field-label">Public URL</div>
                      <div className="field-value">
                        {userSelector?.company?.id ? (
                          <a
                            href={`${userSelector?.company?.location == 1 ? EXTERNAL_AE_URL : EXTERNAL_URL}${userSelector?.company?.slug}-cid-i1${userSelector.company.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                          >
                            {`${userSelector?.company?.location == 1 ? EXTERNAL_AE_URL : EXTERNAL_URL}${userSelector?.company?.slug}-cid-i1${userSelector.company.id}`}
                          </a>
                        ) : (
                          t("members.profile.personalInfo.notProvided")
                        )}
                      </div>
                    </div>
                    <div className="info-field">{/* Empty field to maintain grid layout */}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfoSection;
